import { useMemo } from 'react';

export type ColorLoader = (colorName: string) => string;

export function useColors(): (colorName: string) => string {
    const styles = useMemo(
        () => getComputedStyle(document.documentElement),
        [],
    );
    return (colorName) => styles.getPropertyValue('--' + colorName);
}
